import { Event } from '@/types'
import { StaffCard } from '@/components/common'
import React from 'react'
import { orderBy, snakeCase } from 'lodash'

const MentorAndJudge = ({ event }: { event: Event }) => {
  const mentors = orderBy(event.mentors, ['name'], ['asc'])
  const judges = orderBy(event.judges, ['name'], ['asc'])

  return (
    <section>
      {event.show_mentors && (
        <>
          <div className="text-gray-500 text-lg font-semibold mb-6">
            Meet the Mentors
          </div>
          {mentors && mentors.length > 0 && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 mb-10">
              {mentors.map((mentor, index) => (
                <StaffCard
                  key={`${snakeCase(mentor.name)}_${index}`}
                  name={mentor.name}
                  title={mentor.title}
                  bio={mentor.bio}
                  profileImage={mentor.profile_image || ''}
                  showModel
                  modelTitle="Mentor"
                />
              ))}
            </div>
          )}
          {(!mentors || mentors.length === 0) && (
            <div className="py-12 flex flex-col w-full h-full items-center text-center">
              <span className="text-gray-900 text-lg font-semibold leading-10">
                Our Mentors will be here soon – hang tight! 👀
              </span>
              <p className="text-gray-500 max-w-xl">
                Stay tuned to meet the dedicated mentors who will be available
                to support you throughout your hackathon journey. Get ready to
                receive valuable guidance and insights to take your project to
                the next level!
              </p>
            </div>
          )}
        </>
      )}

      {event.show_judges && (
        <>
          <div className="text-gray-500 text-lg font-semibold mb-6">
            Meet the Judges
          </div>
          {judges && judges.length > 0 && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 mb-10">
              {judges.map((judge, index) => (
                <StaffCard
                  key={`${snakeCase(judge.name)}_${index}`}
                  name={judge.name}
                  title={judge.title}
                  profileImage={judge.profile_image || ''}
                />
              ))}
            </div>
          )}
          {(!judges || judges.length === 0) && (
            <div className="py-12 flex flex-col w-full h-full items-center text-center">
              <span className="text-gray-900 text-lg font-semibold leading-10">
                Our Judges will be here soon – hang tight! 👀
              </span>
              <p className="text-gray-500 max-w-xl">
                Stay tuned to learn more about the impressive panel of judges
                who will be evaluating your projects. Get ready to showcase your
                innovation and creativity!
              </p>
            </div>
          )}
        </>
      )}
    </section>
  )
}

export default MentorAndJudge
